// Admin Info

<template>
	<div class="tools-main" v-if="role=='adm'">

		<div class="header wi8_font">
			App Info
		</div>

		<div class="header">
			<button @click="calcSizes">Refresh</button>
		</div>

		<div class="dat_row" v-for="(size, key) in sizes" :key="'size_'+key">
			<div class="lab">{{ key }}:</div>
			<div class="dat">{{ size.w }}</div>
			<div class="datx">x</div>
			<div class="dat">{{ size.h }}</div>
			<div class="datx" />
			<div class="btn-box">
				<button v-if="key.substr(0,3)=='app'" @click="flashBox(key)">Show</button>
			</div>
		</div>

	</div>
</template>

<script>
import { mapState } from 'vuex';
import { eventBus } from '@/main';
export default {
	data() {
		return {
			sizes: {
				device		: {w:0,h:0},
				window		: {w:0,h:0},
				app_shell	: {w:0,h:0},
				app_body	: {w:0,h:0},
				app_header	: {w:0,h:0},
				app_content	: {w:0,h:0},
				app_footer	: {w:0,h:0}
			},
			styles: {
				app_shell	: {borderColor:"",borderWidth:""},
				app_body	: {borderColor:"",borderWidth:""},
				app_header	: {borderColor:"",borderWidth:""},
				app_content	: {borderColor:"",borderWidth:""},
				app_footer	: {borderColor:"",borderWidth:""},
			}
		};
	},
	computed: {
		...mapState("app", ["role"]),
	},
	methods: {
		flashBox(id) {
			const div = document.getElementById(id);
			if (div) {
				// Set border
				div.style.borderColor="red";
				div.style.borderWidth="2px";

				// Reset border
				setTimeout(() => {
					div.style.borderColor = this.styles[id].borderColor;
					div.style.borderWidth = this.styles[id].borderWidth;
				}, 2000);
			}
		},
		calcStyles() {
			for (const id in this.styles) {
				const div = document.getElementById(id);
				const style = getComputedStyle(div);
				this.styles[id].borderColor = style.borderColor;
				this.styles[id].borderWidth = style.borderWidth;
			}
		},
		calcSizes() {
			this.sizes.device.w = window.screen.availWidth;
			this.sizes.device.h = window.screen.availHeight;

			this.sizes.window.w = window.innerWidth;
			this.sizes.window.h = window.innerHeight;

			this.sizes.app_shell = this.getSize('app_shell'); 
			this.sizes.app_body = this.getSize('app_body'); 
			this.sizes.app_header = this.getSize('app_header'); 
			this.sizes.app_content = this.getSize('app_content'); 
			this.sizes.app_footer = this.getSize('app_footer'); 
		},
		getSize (div_name) {
			var w=0,h=0;
			var div = document.getElementById(div_name);
			if (div) {
				w = div.clientWidth;
				h = div.clientHeight;
			}
			return {w:w,h:h};

		},
	},
	created() {
		eventBus.$emit('popoffall'); // Close all modal windows
	},
	mounted() {
		this.calcStyles();
		this.calcSizes();
	}




}
</script>

<style scoped>
.tools-main {
	height: 100%;
	background-color: #F9FFF9;
	padding: 10px;
	border: solid 0px #009;
}

.header {
	height: 30px;
	overflow: hidden;
	text-align: center;
	color: #369;
	padding: 0px 20px 0px 0px;
	border: solid 0px #369;
}

button {
	width: 60px;
}

.dat_row {
	clear:both;
	height: 40px;
	overflow: hidden;
	text-align: center;
	padding: 10px;
	border: solid 0px #C30;
	border-bottom: solid 1px #999;
}

.lab {
	display: inline-block;
	width: 80px;
	height:30px;
	overflow: hidden;
	border: solid 0px #C30;
}

.dat {
	display: inline-block;
	width: 40px;
	height:30px;
	overflow: hidden;
	text-align: right;
	border: solid 0px #090;
}

.datx {
	display: inline-block;
	width: 20px;
	height:30px;
	overflow: hidden;
	text-align: right;
	border: solid 0px #090;
}

.btn-box {
	display: inline-block;
	width: 80px;
	height:30px;
	overflow: hidden;
	text-align: left;
	border: solid 0px #000;
}

</style>
